import { useCallback, useEffect, useState } from 'react';

export const useCollapse = <T extends { key: string }>(
  items: T[],
  selectedFilters: Record<string, string[]>,
) => {
  const [openCollapseKeys, setOpenCollapseKeys] = useState<Record<string, boolean>>({});

  useEffect(() => {
    const newOpenKeys: Record<string, boolean> = {};

    items.forEach((item) => {
      const isChecked = (selectedFilters[item.key] || []).length > 0;

      if (isChecked) newOpenKeys[item.key] = true;
    });

    setOpenCollapseKeys((prev) => ({ ...prev, ...newOpenKeys }));
  }, [selectedFilters, items]);

  const toggleCollapse = useCallback(
    (key: string) => () => {
      setOpenCollapseKeys((prev) => ({
        ...prev,
        [key]: !prev[key],
      }));
    },
    [],
  );

  return { openCollapseKeys, setOpenCollapseKeys, toggleCollapse };
};
